import React from "react";
import './style.css'

const DoctorCard = (props) => {
  const { doctorName, specialization, avatar, bio, onClick, active } = props
  return (
    <div onClick={onClick} className={active ? "card-container active-card" : "card-container"}>
      <div className="card-topview">
        <img className="doctor_pic" src={avatar} />
        <div className="doctor_right_view">
          <h3>{doctorName}</h3>
          <p>{specialization}</p>
        </div>
      </div>
      <div className="card-content">
        <p>
          {bio}
        </p>
        <button className={active ? "slectbtn activebtn" : 'slectbtn'}>Select {active && <img style={{ width: 22, height: 'auto', objectFit: 'contain', marginLeft: 5, marginTop: -5 }} src={require('../../asstes/images/checkmark.png')} />}
        </button>
      </div>
    </div>
  );
};

export default DoctorCard;
